import { createFileRoute } from '@tanstack/react-router'

import { ReportPage } from '@/components/reports/report-page'
import { RevenueTab } from '@/components/reports/revenue-tab'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/reports/revenue')({
    component: RevenueReportPage,
})

function RevenueReportPage() {
    return (
        <ReportPage title={m.report_page_title_revenue()}>
            <RevenueTab />
        </ReportPage>
    )
}
